module.exports = __webpack_public_path__ + "img/m_gcxx.9facca25.png";